export default __webpack_public_path__ + "static/lukasz_nowacki-bb84e33b00b7eaa5d5c57b929009e608.webp";